// extracted by mini-css-extract-plugin
export var chatButton = "style-module--chat-button--hJAsD";
export var chatContainer = "style-module--chat-container--qF7RV";
export var chatHeader = "style-module--chat-header--MNJcJ";
export var chatWindow = "style-module--chat-window--9XoCQ";
export var chatWrapper = "style-module--chat-wrapper--k5tgC";
export var closeButton = "style-module--close-button--OOnaJ";
export var iframe = "style-module--iframe--pD7BA";
export var rightHandle = "style-module--right-handle--VCfxQ";
export var topHandle = "style-module--top-handle--ygplw";